import CookieCutter from '@unisporkal/cookie-cutter';

export const EzaPreferenceCookie = CookieCutter.define({
  name: 'eza_prf',
  options: {
    maxAgeYears: 1,
  },
});

// TODO: this cookie is also defined in Search and Engine
export const SearchPreferencesCookie = CookieCutter.define({
  name: 'sp',
  options: {
    maxAgeYears: 1,
  },
  values: {
    analog_film: 'af',
    creative_film: 'cf',
    creative_image: 'ci',
    editorial_archival_sort: 'eas',
    editorial_event_sort: 'evs',
    editorial_image: 'ei',
    editorial_sort: 'es',
    film_search_grid_layout: 'fsgl',
    gateway_srp: 'gsrp',
    group_by_event: 'gbe',
    hide_adobe_plugin_banner: 'hapb',
    hide_creative_banner: 'hcb',
    hide_prestige_banner: 'hpb',
    image_search_grid_layout: 'isgl',
    mixed_film: 'mf',
    mixed_image: 'mi',
    refinement_panel_state: 'rps',
    saved_filters: 'sf',
    search_details: 'sd',
    search_grid_layout: 'sgl',
  },
});
